import { StateTagType } from '@shared/ui-components/state-tag/models/tag.model';
import { ProcedureCodes } from '@core/domain/model/procedures/procedure-codes';
import { PagedResponse } from '@core/services/request/model/request.model';

export type ProcedureListing = {
  isDraft: false;
  requestCode: string;
  stateCode: string;
  stateDesc: string;
  stateType: StateTagType;
  procedureDesc: string;
  procedureCode: ProcedureCodes;
  societyName: string;
  societyCode: string;
  installationName: string;
  installationCode: string;
  cups: string;
  lastModificationDate: Date;
};

export type ProcedureListingResponse = PagedResponse<ProcedureListing>;

export enum ProceduresListingTab {
  ALL = 'all', // Todos (menos DRAFTS) = REQUIRED + PENDING + CLOSED
  DRAFTS = 'drafts', // Borradores
  REQUIRED = 'required', // Información requerida
  PENDING = 'pending', // En trámite
  CLOSED = 'closed', // Cerrados
}

export type DraftListing = {
  isDraft: true;
  id: number;
  procedureDesc: string;
  procedureCode: ProcedureCodes;
  societyName: string;
  societyCode: string;
  cif: string;
  installationName: string;
  installationCode: string;
  cups: string;
  lastModificationDate: string;
  sendCRM: boolean;
  title: string;
};
export type DraftListingResponse = PagedResponse<DraftListing>;
export type ProceduresListingFilters = {
  requestNumber?: string;
  societies?: Array<string>;
  installations?: Array<string>;
  procedureTypes?: Array<string>;
};
